import React from "react";
import TldrNavDropdown from "../_components/common/TldrNavDropdown";
import TldrNotificationDropdown from "../_components/common/TldrNotificationDropdown";
import { StyledTldrDropDown } from "./StoryDetailsPageStyles";
import {
  Icon,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Flex,
  Text,
  Box,
  HStack,
  Tooltip,
} from "@chakra-ui/react";
import TldrHelpAndSupportMenu from "../_components/common/TldrHelpAndSupportMenu";
import TldrWorkspaceAddMembersModal from "../_components/common/TldrWorkspaceAddMembersModal";
import { FaUserPlus } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useState } from "react";
import { isFreePlanOrTrialEnded } from "../_utils/isFreePlan";
import TldrUpgradeSubscriptionModal from "../_components/common/modals/TldrUpgradeSubscriptionModal";
import {
  inviteMembersFeatures,
  UPGRADE_PLAN_IMAGE_LINK,
} from "../_utils/constants";

function Tabbar(props) {
  const { t } = useTranslation(["navbar"]);
  const subscription = useSelector((state) => state.subscription);
  const [showWorkspaceAddMembersModal, setShowWorkspaceAddMembersModal] =
    useState(false);
  const [showUpgradeSubscriptionModal, setShowUpgradeSubscriptionModal] =
    useState(false);
  let brandIconStyle = {
    "& > a > svg": {
      width: "32px",
      height: "32px",
    },
  };

  const { canInviteMemberToWorkspace } = useSelector(
    (state) => state.permissions.workspacePermissionChecks
  );
  //theme styles keep being overriden by Button styles so need styles here
  let iconButtonStyle = {
    color: "brand.white",
    backgroundColor: "transparent",
    _hover: {
      backgroundColor: "transparent",
    },
    _active: {
      color: "primary.400",
    },
  };

  const onInviteMembers = () => {
    if (isFreePlanOrTrialEnded(subscription?.subscribedPlan)) {
      setShowUpgradeSubscriptionModal(true);
    } else {
      setShowWorkspaceAddMembersModal(true);
    }
  };

  return (
    <>
      <Flex
        direction={"row"}
        justify={"space-between"}
        align={"center"}
        grow={1}
        height={"60px"}
        px={"10px"}
        backgroundColor={"brand.grey-darker"}
      >
        {props?.tabs?.map((tab, i) => {
          let TabIcon = tab.icon;
          return tab.type === "tldrDropdown" ? (
            <StyledTldrDropDown key={tab.key}>
              <HStack>
                {canInviteMemberToWorkspace && (
                  <Tooltip label={t("invite_members")} hasArrow>
                    <IconButton
                      borderRadius="full"
                      onClick={onInviteMembers}
                      aria-label="Options"
                      icon={<FaUserPlus />}
                      variant="secondary"
                      size="sm"
                      fontSize="lg"
                    />
                  </Tooltip>
                )}
                <TldrHelpAndSupportMenu />
                <TldrNotificationDropdown />
                <TldrNavDropdown {...props} />
              </HStack>
            </StyledTldrDropDown>
          ) : tab.type === "dropdown" ? (
            <Menu isLazy key={tab.key}>
              <MenuButton
                id="dropdown-custom-components"
                icon={<Icon as={TabIcon} />}
                as={IconButton}
              />
              <MenuList>
                {tab?.options?.map((option, index) => {
                  let OptionIcon = option.icon;
                  return (
                    <MenuItem
                      key={index}
                      eventKey={index}
                      icon={<Icon as={OptionIcon} />}
                    >
                      <Flex
                        direction={"column"}
                        justify={"space-evenly"}
                        h={"50px"}
                      >
                        <Text fontSize={"xs"}>{option.label}</Text>
                      </Flex>
                    </MenuItem>
                  );
                })}
              </MenuList>
            </Menu>
          ) : tab.type === "fa" ? (
            <Flex direction={"column"} key={tab.key}>
              <IconButton
                size={"sm"}
                fontSize="lg"
                alignSelf={"center"}
                sx={iconButtonStyle}
                aria-label={tab?.label ? tab?.label : tab.key}
                icon={TabIcon ? <TabIcon /> : <></>}
                isActive={props.isItemActive(tab)}
                onClick={() => {
                  props.onItemClick(tab);
                }}
              />
              {props.showLabels && (
                <Text
                  fontSize={"xs"}
                  color={
                    props.isItemActive(tab) ? "primary.400" : "brand.white"
                  }
                >
                  {tab.label}
                </Text>
              )}
            </Flex>
          ) : (
            <Box sx={brandIconStyle} key={tab.key}>
              <TabIcon />
            </Box>
          );
        })}
      </Flex>
      {showWorkspaceAddMembersModal ? (
        <TldrWorkspaceAddMembersModal
          onHide={() => setShowWorkspaceAddMembersModal(false)}
        />
      ) : null}
      {showUpgradeSubscriptionModal ? (
        <TldrUpgradeSubscriptionModal
          show={showUpgradeSubscriptionModal}
          featureList={inviteMembersFeatures}
          image={UPGRADE_PLAN_IMAGE_LINK}
          title={t("invite_member_feature_heading", {
            ns: "workspace",
          })}
          subtitle={t("invite_member_feature_description", {
            ns: "workspace",
          })}
          onHide={() => setShowUpgradeSubscriptionModal(false)}
        />
      ) : null}
    </>
  );
}

export default Tabbar;
